import { message } from "antd";

export function copyToClipboard(text, successMsg = "URL copied to clipboard!") {
    navigator.clipboard.writeText(text).then(r =>
        message.success(successMsg)
    )
}